export default {"src":"/_next/static/media/pointing_avatar_cat.58e4220f.svg","height":48,"width":62,"blurWidth":0,"blurHeight":0};